"use client";

import dynamic from "next/dynamic";
import { ChatCircleDotsIcon } from "@phosphor-icons/react";
import { useEffect, useState } from "react";

import {
  AI_ASSISTANT_CONTEXT_EVENT,
  type AiAssistantPageContext,
} from "@/components/public/ai-assistant-context";

const AiAssistant = dynamic(() => import("@/components/public/ai-assistant"), {
  ssr: false,
});

function documentContext(): AiAssistantPageContext | null {
  const sailingId = document.documentElement.dataset.aiSailingId;
  const title = document.documentElement.dataset.aiSailingTitle;
  const quoteUrl = document.documentElement.dataset.aiQuoteUrl;
  return sailingId && title && quoteUrl ? { sailingId, title, quoteUrl } : null;
}

export function AiAssistantLoader({
  defaultLanguage,
  showPrices = true,
}: {
  defaultLanguage: "tr" | "en";
  showPrices?: boolean;
}) {
  const [activated, setActivated] = useState(false);
  const [pageContext, setPageContext] = useState<AiAssistantPageContext | null>(null);

  useEffect(() => {
    setPageContext(documentContext());
    const update = (event: Event) =>
      setPageContext((event as CustomEvent<AiAssistantPageContext | null>).detail);
    window.addEventListener(AI_ASSISTANT_CONTEXT_EVENT, update);
    return () => window.removeEventListener(AI_ASSISTANT_CONTEXT_EVENT, update);
  }, []);

  if (activated)
    return (
      <AiAssistant
        initiallyOpen
        pageContext={pageContext}
        defaultLanguage={defaultLanguage}
        showPrices={showPrices}
      />
    );

  return (
    <button
      className="ai-assistant-launcher"
      type="button"
      onClick={() => setActivated(true)}
      aria-label={
        defaultLanguage === "tr" ? "Cruise asistanını aç" : "Open cruise assistant"
      }
      aria-haspopup="dialog"
    >
      <ChatCircleDotsIcon size={25} weight="fill" aria-hidden="true" />
      <span>
        {defaultLanguage === "tr" ? "AI Cruise Asistanı" : "AI Cruise Assistant"}
      </span>
    </button>
  );
}
